export default {
    accounts: 'cfportal/accounts',
    accountUsers: 'cfportal/accountUsers',
    shortCodeDetails: 'cfportal/shortCodeDetails',
    reserveShortCode: 'cfportal/reserveShortCode'
}